var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as angular from 'angular';
import { reloadCurrentRoute } from '../../../../../../src/app/shared/utils/navigate-force-reload';
var PhoneDontAccept = /** @class */ (function () {
    function PhoneDontAccept(InboundNumbersService, $stateParams, $state, Toast, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.state = $state;
        this.toast = Toast;
        this.router = Router;
    }
    PhoneDontAccept.prototype.$onInit = function () {
        this.settings = angular.copy(this.settings);
        this.msisdnId = this.msisdnid;
    };
    PhoneDontAccept.prototype.save = function () {
        var _this = this;
        var updatedSettings = __assign({}, this.settings, { checked: true });
        this.settings = updatedSettings;
        this.InboundNumbersService.setNumberSettings({ id: this.msisdnid }, { dontAcceptCallConfiguration: this.settings }, function () {
            _this.hide();
            _this.toast.success('CHANGES_SAVED');
            reloadCurrentRoute(_this.router);
        });
    };
    PhoneDontAccept.prototype.onMessageUpdate = function () {
        var _this = this;
        this.InboundNumbersService.getNumberSettings({ id: this.msisdnid }, function (settings) {
            _this.settings.voicemailMessageFile = settings.dontAcceptCallConfiguration.voicemailMessageFile;
            _this.settings.promptMessageFile = settings.dontAcceptCallConfiguration.promptMessageFile;
        });
    };
    PhoneDontAccept.$inject = ['InboundNumbersService', '$stateParams', '$state', 'Toast', 'Router'];
    return PhoneDontAccept;
}());
export default {
    controller: PhoneDontAccept,
    template: require('./phone.details.dont-accept.html'),
    bindings: {
        hide: '&',
        settings: '<',
        msisdnid: '<'
    }
};
